export default __webpack_public_path__ + "static/2366-fc918531db650749c3f8cd11f9a5fd80.gif";